<template>
    <icon-label
        :size="size"
        :show-icon="showIcon"
        :show-label="showLabel"
        :img-src="imgSrc"
        :label="label" />
</template>

<script setup>
import IconLabel from '@/common/icon-label/icon-label.vue';
import { computed } from 'vue';
import { SOURCES } from '@/voc/constants/feedback.js';

const { type } = defineProps({
    type: {
        type: String,
        default: '',
    },
    showIcon: {
        type: Boolean,
        default: true,
    },
    showLabel: {
        type: Boolean,
        default: false,
    },
    size: {
        type: String,
        default: 'large',
    },
});

const imgSrc = computed(() => {
    const icon = SOURCES[type]?.icon || 'source-icon/unknown-icon.svg';

    return require(`@img/voc/${icon}`);
});
const label = computed(() => SOURCES[type]?.label || `Unknown source ${type}`);
</script>
